import React, { createContext, useContext, useState, ReactNode, FC } from 'react';

interface VeriffSessionContextType {
  sessionUrl: string | null;
  setSessionUrl: (url: string | null) => void;
}

const VeriffSessionContext = createContext<VeriffSessionContextType | undefined>(undefined);

export const VeriffSessionProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [sessionUrl, setSessionUrl] = useState<string | null>(null);

  return (
    <VeriffSessionContext.Provider value={{ sessionUrl, setSessionUrl }}>{children}</VeriffSessionContext.Provider>
  );
};

export const useVeriffSession = (): VeriffSessionContextType => {
  const context = useContext(VeriffSessionContext);
  if (!context) {
    throw new Error('useVeriffSession must be used within a VeriffSessionProvider');
  }
  return context;
};
